// extracted by mini-css-extract-plugin
export var appStoreButton = "vkEbK";
export var appStoreButtons = "f+0X1";
export var asset = "_0oCu7";
export var icon = "_9v37D";
export var image = "OeHOD";
export var main = "A2a43";
export var qr = "Mtpuc";
export var qrLink = "HxmWK";
export var qrText = "xdjeT";
export var text = "lWECo";
export var title = "lAoGA";